import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import api from '../../services/api';
import { initializeChatwoot } from '../../utils/chatwoot';

interface ChatwootProviderProps {
  children: React.ReactNode;
}

export const ChatwootProvider: React.FC<ChatwootProviderProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth0();

  useEffect(() => {
    if (isAuthenticated && user) {
      const userName =
        user.name ||
        (user.given_name || user.family_name
          ? `${user.given_name || ''} ${user.family_name || ''}`.trim()
          : undefined) ||
        user.nickname ||
        user['https://phox.pharmaguide.com/user_metadata']?.firstName ||
        user['https://phox.pharmaguide.com/user_metadata']?.name ||
        user.email?.split('@')[0] ||
        'User';

      // Fetch HMAC hash from backend, then initialize
      api.get<{ identifier_hash: string | null }>('/api/auth/chatwoot-hash')
        .then((res) => {
          initializeChatwoot({
            user_id: user.sub,
            name: userName,
            email: user.email || '',
            identifier_hash: res.data.identifier_hash || undefined,
          });
        })
        .catch(() => {
          // Initialize without identity verification if backend call fails
          initializeChatwoot({
            user_id: user.sub,
            name: userName,
            email: user.email || '',
          });
        });
    }
  }, [isAuthenticated, user]);

  return <>{children}</>;
};
